//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// chrome-card imports
import { IContainer, IProps, IState } from "./ChromeWelcome.d";
import { styles, content } from "./ChromeWelcome.styles";
// other components
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import { H2 } from "@ui";
// util
import { PostMessageManager } from "@util/post-message.util";
import { logoClockWhite } from "@img/logos";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setActiveViewFeed } from "@actions/chrome-extension.actions";
// material-ui
import { Button } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class ChromeWelcomeCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    // if we're onboarding, make sure the sidebar is open
    PostMessageManager.openSidebar(true);
  }

  private beginOnboarding = () => {
    this.props.openOnboardingDialog();
  };

  private renderAction = () => {
    const { onboardingFinished } = this.props;

    if (onboardingFinished) {
      // this really shouldn't happen, but allow an escape
      return (
        <div style={content.button}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.props.setActiveViewFeed()}
            classes={{ label: this.props.classes.label }}
          >
            Finish
            <ChevronRight className={this.props.classes.icon} />
          </Button>
        </div>
      );
    }

    return (
      <div style={content.button}>
        <Button
          variant="contained"
          color="primary"
          onClick={this.beginOnboarding}
          classes={{ label: this.props.classes.label }}
        >
          Continue Setup
          <ChevronRight className={this.props.classes.icon} />
        </Button>
      </div>
    );
  };

  public render() {
    if (!this.props.onboardingLoaded && this.props.onboardingDialogOpen) {
      return (
        <div className={this.props.classes.container}>
          <div style={content.container}>
            <CircularProgress />
          </div>
        </div>
      );
    }

    if (this.props.onboardingLoaded && this.props.onboardingDialogOpen) {
      // if onboarding dialog is open, don't show anything here because it looks weird
      return <span />;
    }

    return (
      <div className={this.props.classes.container}>
        <div style={content.container}>
          <div style={content.hero}>
            <img src={logoClockWhite} style={content.logo} />
          </div>
          <div style={content.body}>
            <H2 style={content.header}>Finish setup to get started with Clockwise</H2>
            {this.renderAction()}
          </div>
        </div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
const ChromeWelcomeStyled = withStyles(styles)(ChromeWelcomeCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    onboardingLoaded: state.onboarding.onboardingLoaded,
    onboardingFinished: state.onboarding.onboardingFinished,
  };
}

export const ChromeWelcome = connect(mapStateToProps, {
  setActiveViewFeed,
})(ChromeWelcomeStyled);
